import '../blocks/beratersuche/js/script.js';
import '../blocks/bonusrechner/js/script.js';
import '../blocks/flag/js/script.js';
import '../blocks/flipcards/js/script.js';
import '../blocks/relevant-topics/js/script.js';
import '../blocks/singlestaff/js/script.js';
// import '../components/**/script.js';
// import '../filters/**/script.js';



// WEBPACK FOOTER //
// ./src/js/script.js